import React, { Fragment, useState } from "react";
import "./Node.css";

function Node({ node, onClick, selectedNode }) {
  const [isActive, setIsActive] = useState(false);


  const handleCenterNodeClick = () => {
    setIsActive(!isActive);
    onClick(node);
    console.log(node)

  };
  

  const inactiveNode = "#A3DAF7"
  const activeNode = "#A3DAF7"

  const isSelected = selectedNode === node;

  const isCenterNode = node.data.name === "Forest\nBioeconomy";
  const width = 150;
  const height = 60;
  const radius = Math.sqrt(width * width + height * height) / 2; // Set a radius value for the circle

  const fontSizeInner =
    window.innerWidth < 768
      ? node.depth === 0
        ? 18
        : 12
      : node.depth === 0
      ? 32
      : 20;

  const fontSizeOuter = 16

  const patternId = `image-${node.data.name}`; // unique ID for each pattern

  return (
    <Fragment>
      {node.depth === 1 && ( // Add the images for the first children only
        <defs>
          <pattern
            id={patternId}
            height="1"
            width="1"
            patternUnits="objectBoundingBox"
          >
            <image
              href={node.data.imageUrl}
              x="0"
              y="0"
              height="160"
              width="160"
              preserveAspectRatio="none"
            />
          </pattern>
        </defs>
      )}

      {node.depth === 0 && (
        <circle
          className={`lineargradient ${isActive ? "active" : ""}`}
          r={100}
          fill="url('#circle-pattern')"
          onClick={handleCenterNodeClick}
        />
      )}
      {node.depth === 1 ? ( // Condition added here to make the first children circular
        <circle
          className={`Node ${isSelected ? "selected" : ""}`}
          r={radius}
          fill={`url('#${patternId}')`}
          stroke={node.data.children ? "" : "lightgreen"}
          strokeWidth={1}
          strokeOpacity={!node.data.children ? 0.6 : 1}
          onClick={() => {
            setIsActive(!isActive);
            onClick(node);
          }}
        />
      ) : (
        node.depth !== 0 && (
          <rect
            className={`Node ${isActive ? "selected" : ""}`}
            height={height}
            width={190}
            y={-height / 2}
            x={-190 / 2}
            fill={isActive ? activeNode : inactiveNode}
            stroke={node.data.children ? "" : "lightgreen"}
            strokeWidth={1}
            strokeOpacity={!node.data.children ? 0.6 : 1}
            rx={!node.data.children ? 10 : 20}
            onClick={() => {
              setIsActive(!isActive);
              onClick(node);
            }}
          />
        )
      )}
      <g>
        {isCenterNode && (
          <rect
            className="NodeBackdrop"
            height={height}
            width={width - width / 8}
            y={-height / 2}
            x={-width / 2.3}
            fill="rgba(200, 200, 200, 0.4)"
            pointerEvents="none"
          />
        )}
        <g
          transform={
            node.depth === 0
              ? "translate(0,0)"
              : node.depth === 1
              ? "translate(0,110)"
              : "translate(0,0)"
          }
        >
          {" "}
          {/* Apply the transformation only for first children */}
          <text
            dy={".33em"}
            fontSize={node.depth <= 1 ? fontSizeInner : fontSizeOuter }
            fontFamily="Fira Sans, sans-serif"
            textAnchor={"middle"}
            style={{
              pointerEvents: "none",
              whiteSpace: "pre-line",
            }}
            fill={node.depth <= 1 ? "white" : "#4A83A8"} // change color based on whether node is a leaf or not
          >
            {node.data.name.split("\n").map((line, index) => (
              <tspan key={index} x="0" dy={index === 0 ? 0 : "1em"}>
                {line}
              </tspan>
            ))}
          </text>
        </g>
      </g>
    </Fragment>
  );
}

export default Node;



// WEBPACK FOOTER //
// ./src/Node.js